import { render, staticRenderFns } from "./SheetTableConfig.vue?vue&type=template&id=1bc7b421&scoped=true"
import script from "./SheetTableConfig.vue?vue&type=script&lang=js"
export * from "./SheetTableConfig.vue?vue&type=script&lang=js"
import style0 from "./SheetTableConfig.vue?vue&type=style&index=0&id=1bc7b421&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc7b421",
  null
  
)

export default component.exports